import './faq-style.css';
import {FaqProps} from "./FaqProps";
import {FaqContent} from "./FaqContent";

export const Faq = (faqs: FaqProps) => {

    return(
      <section className={'Faq'} id={'faq'}>
          <div className={'container'}>
              <h1 className={'section__title'}>Частые вопросы</h1>
              <div className={'faq-content'}>
                  {faqs.faq.map((faq, idx) => (
                      <FaqContent question={faq.question} answer={faq.answer}/>
                  ))}
              </div>
          </div>
      </section>
    );
}